import styled from 'styled-components';
import WBSearchableSelect from './elements/WBSearchableSelect';

export const StyledSearchableSelect = styled(WBSearchableSelect)`
  width: 100%;
`;
